import { useState, useRef, useEffect, useCallback } from 'react'
// import { useLocation } from 'react-router-dom'
import dayjs from 'dayjs'
import {ListTabsPanel, SynchronizeIcon} from 'common/components'
import {useGetReconciliations} from '..'
import { useXeroSync } from '..'
import { useStore, setDueTime } from './store'
// import styles from './TopPanel.module.scss'
// import {AddButton} from './AddButton'
import xeroImg from 'assets/images/services-xero.png'

const TABS = [
  {key: '',             label: 'Reconciliation'},
  {key: 'statements',   label: 'Xero Statement'},
  {key: 'transactions', label: 'Account Transactions'},
]

export const TopPanel = () => {
  // const {pathname} = useLocation()
  // const page = useStore((state) => state.pageNumberReconciliation)
  const {data: rData} = useGetReconciliations({ page: 1 })
  // const {data: sData} = useGetStatements({ page: 1 })
  // const {data: tData} = useGetTransactions({ page: 1 })

  const tabs = TABS.map((x:any, index:number) => ({
    key: x.key,
    label: 
      ((index === 0) && ('number' === typeof rData?.meta?.total)) ? `${x.label} (${rData.meta.total})`
      :
      x.label
  }))
  return (
    <div style={{
      position: 'relative'
    }}>
      <ListTabsPanel
        noGap
        path="reconciliations"
        tabs={tabs}
      />
      <div style={{
        position: 'absolute',
        right: 0,
        bottom: '18px'
      }}>
        <XeroSync />
      </div>
    </div>
  )
}

const XeroSync = () => {
  const { mutate: sync } = useXeroSync()
  const dueTime = useStore((state) => state.dueTime)
  const [trigger, setTrigger] = useState<number>(0)
  const refTimer = useRef(null)

  const isProcessing = !!dueTime
  
  const clearTimer = useCallback( () => {
    if (!!refTimer.current) {
      clearInterval(refTimer.current)
    }
  }, [])
  const startTimer = () => {
    refTimer.current = setInterval(
      () => setTrigger(
        (x:number) => (x+1)
      ),
      1000
    )
  }

  useEffect(() => {
    if (!!dueTime) {
      startTimer()
    }
    return () => {
      clearTimer()
    }
  }, [])

  const onClick = () => {
    setDueTime(
      dayjs()
      .add(10, 'minute')  // .add(30, 's')
      .format('YYYY-MM-DD HH:mm:ss')
    )
    sync(null)
    startTimer()
  }

  const diff = !dueTime ? null : dayjs(dueTime).diff(dayjs(), 's')
  const m = !diff ? 0 : Math.floor(diff/60)
  const s = !diff ? 0 : (diff % 60)
  // console.log(m, s)

  if ((diff !== null) && (diff <= 0)) {
    clearTimer()
    setDueTime(null)
  }

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: '8px'
    }}>
      <span style={{
        color: 'transparent'
      }}>
        {trigger}
      </span>

      <img width={58} height={14} src={xeroImg} alt="Xero" />
      { isProcessing ?
        <p style={{
          color: '#A1ABB0',
          fontSize: '12px',
        }}>
          Processing
          &nbsp;
          ({(m > 10) ? m:`0${m}`}:{(s > 10) ? s:`0${s}`})
        </p>
        :
        <button style={{
          padding: 0,
          lineHeight: 0,
          border: 'none',
          backgroundColor: 'transparent',
          cursor: 'pointer'
        }} onClick={onClick}>
          <SynchronizeIcon />
        </button>
      }
    </div>
  )
}
